module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"allNews":"全部新闻"},"en":{"allNews":"All News"}}')
  delete Component.options._Ctor
}
